<template>
  <DxPopup
    :visible="visible"
    :show-title="true"
    :title="$t('stock_management.orders.title')"
    :width="'80%'"
    :height="'85%'"
    @hiding="onClose"
  >
    <div style="display: flex; flex-direction: column; height: 95%">
      <DxDataGrid
        ref="ordersGrid"
        class="orders_grid"
        :data-source="ordersDataSource"
        :show-borders="true"
        :column-auto-width="true"
        :remote-operations="true"
        :hover-state-enabled="true"
        :show-column-headers="true"
        :repaint-changes-only="true"
        :selected-row-keys="selectedOrderUuids"
        @selection-changed="onGridSelectionChanged($event)"
        @row-click="onRowClick"
        :height="'95%'"
      >
        <DxColumn
          dataField="order_number"
          :caption="$t('stock_management.orders.order_number')"
          :filter-operations="['contains']"
          :allowSorting="false"
          width="12%"
        />
        <DxColumn
          dataField="order_type"
          :caption="$t('stock_management.orders.order_type')"
          :filter-operations="['contains']"
          :allowSorting="false"
          width="12%"
        />
        <DxColumn
          dataField="contract_number"
          :caption="$t('stock_management.contracts_purchase_sale.contract_number')"
          :filter-operations="['contains']"
          :allowSorting="false"
          width="12%"
        />
        <DxColumn
          dataField="product_name"
          :caption="$t('common.product')"
          :filter-operations="['contains']"
          :allowSorting="false"
          width="15%"
        />
        <DxColumn
          dataField="legal_entity_name"
          :caption="$t('common.legal_entity_name')"
          :filter-operations="['contains']"
          :allowSorting="false"
          alignment="center"
          width="15%"
        />
        <DxColumn
          dataField="partner_name"
          :caption="$t('common.partner')"
          :filter-operations="['contains']"
          :allowSorting="false"
          alignment="center"
          width="15%"
        />
        <DxColumn
          dataField="ordered_quantity"
          :caption="$t('stock_management.orders.ordered_quantity')"
          :dataType="'number'"
          :filter-operations="['contains']"
          :allowSorting="false"
          width="10%"
        />
        <DxColumn
          dataField="receptioned_quantity"
          :caption="$t('stock_management.orders.receptioned_quantity')"
          :dataType="'number'"
          :filter-operations="['contains']"
          :allowSorting="false"
          width="10%"
        />
        <DxSelection :mode="multiselect ? 'multiple' : 'single'" showCheckBoxesMode="always" selectAllMode="page" />
        <DxFilterRow :visible="true" />
        <DxPaging :total="3500" :page-size="15" />
        <DxPager
          :visible="true"
          :allowed-page-sizes="[15, 25, 50, 100]"
          display-mode="compact"
          :show-page-size-selector="true"
          :show-info="true"
          :show-navigation-buttons="true"
          :info-text="$t('common.page_info')"
        />
      </DxDataGrid>
      <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: auto; padding-top: 16px">
        <button class="btn btn-outline-primary col-lg-2 apply-btn" @click="onContinue">{{ $t("common.continue") }}</button>
      </div>
    </div>
  </DxPopup>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  DxDataGrid,
  DxColumn,
  DxSelection,
  DxFilterRow,
  DxPaging,
  DxPager,
} from "devextreme-vue/data-grid";
import DxPopup from "devextreme-vue/popup";
import CustomStore from "devextreme/data/custom_store";
import { ORDER_TYPE } from "@/pages/stock-management/orders/config/orderTypes";

export default {
  name: "OrdersSelector",
  components: {
    DxDataGrid,
    DxColumn,
    DxPopup,
    DxPaging,
    DxSelection,
    DxFilterRow,
    DxPager,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedOrderUuids: {
      type: Array,
      default: () => [],
    },
    multiselect: {
      type: Boolean,
      default: false,
    },
    filterData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      ordersDataSource: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
  methods: {
    ...mapActions({
      searchOrders: "smOrders/getSmOrders",
    }),
    initDataSource() {
      this.ordersDataSource = new CustomStore({
        key: "uuid",
        load: (loadOptions) => {
          let filter = this.filterData.filter ? [...this.filterData.filter] : [];

          // Only show purchase orders (cumparare type)
          if (!filter.some((f) => Array.isArray(f) && f[0] === "cumparare_type")) {
            filter.push(["cumparare_type", "=", ORDER_TYPE.PURCHASE]);
          }

          const payload = {
            ...loadOptions,
            filter: filter,
          };

          return this.searchOrders(payload).then((response) => ({
            data: response.data.data || [],
            totalCount: response?.data?.pagination?.total ?? 1,
          }));
        },
      });
    },
    onClose() {
      this.$emit("close");
    },
    onGridSelectionChanged(e) {
      if (!this.multiselect && e.selectedRowsData.length > 0) {
        // Auto-select and emit for single select mode
        const selectedOrder = e.selectedRowsData[0];
        if (selectedOrder) {
          this.$emit("continue", [selectedOrder]);
          this.onClose();
        }
      }
    },
    onRowClick(e) {
      if (!this.multiselect) {
        // Auto-select on row click for single select mode
        e.component.selectRows([e.data.uuid], true);
      }
    },
    onContinue() {
      const grid = this.$refs.ordersGrid?.instance;
      if (grid) {
        const selectedRowsData = grid.getSelectedRowsData();
        if (selectedRowsData.length > 0) {
          this.$emit("continue", selectedRowsData);
          this.onClose();
        }
      }
    },
  },
  mounted() {
    this.initDataSource();
  },
};
</script>

<style scoped>
.orders_grid {
  width: 100%;
}
</style>
